import React, { useEffect, useState } from "react";
import { flushSync } from "react-dom";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { t } from "i18next";

const styles = {
  datePicker: {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
};

export default function DatePickerComponent({
  errorMsg,
  handleChange,
  field,
  sectionName,
  value,
  currentObjFieldError,
  isApplicationSubmitted,
  propertyId,
  unitId,
  loanDetails,
  dynamicConfig,
}: {
  errorMsg: any;
  handleChange: any;
  field: any;
  sectionName: string;
  value: any;
  currentObjFieldError: any;
  isApplicationSubmitted: boolean;
  propertyId: any;
  unitId: any;
  loanDetails: any;
  dynamicConfig: any;
}) {
  // Local buffer, same reasoning as TextFieldComponent — `value` round-trips
  // through LoansContext before the picked date would otherwise reflect,
  // which reads as a delay after picking a date.
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        sx={(styles.datePicker, { width: "100%" })}
        value={localValue ? dayjs(localValue) : null}
        onChange={(newValue) => {
          const isoDate: any = newValue?.toISOString(); // get ISO string from Day.js

          const date = new Date(isoDate);
          if (isNaN(date.getTime())) return null;

          const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          const formattedDate = new Intl.DateTimeFormat("en-CA", {
            timeZone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(date);
          // flushSync — see TextFieldComponent for why this is needed to
          // avoid React 18 batching this with LoansContext's heavier
          // update. (startTransition was also tried, to yield/paint in
          // between, but caused hangs under rapid input — reverted.)
          flushSync(() => setLocalValue(formattedDate));
          handleChange(formattedDate, "date", field, sectionName, propertyId, unitId);
        }}
        slotProps={{
          textField: {
            size: "small",
            error: Boolean(errorMsg?.length && currentObjFieldError),
            helperText: currentObjFieldError ? t(errorMsg) : "",
          },
        }}
        format="MM/DD/YYYY"
        disabled={
          dynamicConfig?.allowEditAfterSubmit &&
          !(
            field?.isAutoCalculated &&
            field?.isAutoCalculated({
              sizingType: loanDetails?.sizingType,
            })
          )
            ? false
            : isApplicationSubmitted ||
              field?.isAutoCalculated({ sizingType: loanDetails?.sizingType })
        }
      />
    </LocalizationProvider>
  );
}
